import * as moment from "moment";

export function formatDate(date: moment.Moment | string | Date, fmt?: string) {
    const d = moment(date);
    return d.isValid() ? d.format(fmt || "D. M. YYYY") : null;
}